/**
 * @file comfort-phrase.schema.ts
 * @description Define o schema Zod para a entidade 'ComfortPhrase'.
 * Cada documento representa uma frase de conforto ou encorajamento
 * que pode ser exibida em locais de "estado vazio" na interface do usuário.
 */

import { z } from 'zod';

// --- Main ComfortPhrase Schema ---

/**
 * Define o schema principal e completo para a entidade ComfortPhrase.
 */
const ComfortPhraseSchema = z.object({
  /**
   * O texto da frase a ser exibida.
   * Ex: "Respire fundo, você está fazendo um ótimo trabalho.".
   */
  text: z.string(),

  /**
   * O nome do ícone a ser exibido junto com a frase.
   * O frontend usará este nome para buscar o componente de ícone correspondente.
   * Ex: "heart", "sparkles", "hug".
   */
  icon: z.string(),
  
  /**
   * Campos de auditoria para rastrear a criação e modificação da frase.
   */
  createdAt: z.date(),
  updatedAt: z.date(),
  deletedAt: z.date().nullable(),
});


// --- Inferred TypeScript Types ---

type ComfortPhrase = z.infer<typeof ComfortPhraseSchema>;


// --- Public Exports ---

export { ComfortPhraseSchema };
export type { ComfortPhrase };